module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"attach_tag":"タグをつける","already_added":"すでに追加済みです。","undefined":"未分類","cant_add_tag":"タグを追加できませんでした。","added_to_undefined":"を未分類に追加しました。","add":"追加"}}')
  delete Component.options._Ctor
}
